import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Pagination from "@mui/material/Pagination";
import { TextInput } from "hesus-ui-kit";
import "./PaginationData.scss";

const PaginationData = (props) => {
  const {
    t,
    pageCount,
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
    pageStart,
    setPageStart,
  } = props;

  const goToPage = (e) => {
    setCurrentPage(Number(e.target.value));
    switchPage(Number(e.target.value));
  };

  const switchPage = (selectedPage) => {
    let pageStartLocal;
    if (selectedPage === 1) {
      pageStartLocal = 0;
    } else {
      pageStartLocal = pageSize * selectedPage - pageSize;
    }
    setCurrentPage(selectedPage);
    setPageStart(pageStartLocal);
  };

  const handleChangePage = (event, newPage) => {
    switchPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(Number(event.target.value));
  };

  return (
    <div className="footer-pagination ">
      <div className="pagination__container">
        <TextInput
          type="text"
          value={pageSize || 10}
          id="pagesize"
          label={t("GENERAL_LIST_SHOW")}
          inputClass="table-pagination__page-size-input"
          placeholder=""
          onChange={handleChangeRowsPerPage}
          containerClass="table-pagination__page-size-wrapper"
          labelClass="table-pagination__page-size-label"
        />
        <TextInput
          type="text"
          value={currentPage || 1}
          id="pagesize"
          label={t("GENERAL_LIST_GO_TO_PAGE")}
          inputClass="table-pagination__go-to-page-input"
          placeholder=""
          onChange={goToPage}
          containerClass="table-pagination__go-to-page-wrapper"
          labelClass="table-pagination__go-to-page-label"
        />
        <Pagination
          count={Math.ceil(pageCount / pageSize)}
          showFirstButton
          showLastButton
          defaultPage={1}
          page={currentPage}
          onChange={handleChangePage}
        />
      </div>
    </div>
  );
};

export default withTranslation()(PaginationData);
